import Swiper, { Navigation } from "swiper";

export default (config = {}) => ({
  swiper: null,

  initSlider() {
    if (!this.$refs.slider) return;

    this.swiper = new Swiper(this.$refs.slider, {
      slidesPerView: config.perViewMobile ?? 1.2,
      spaceBetween: config.gapMobile ?? 8,
      breakpoints: {
        768: {
          slidesPerView: config.perViewTablet ?? 2.2,
          spaceBetween: config.gapTablet ?? 8,
        },
        1024: {
          slidesPerView: config.perViewDesktop ?? 4,
          spaceBetween: config.gapDesktop ?? 8,
        },
      },
      navigation: {
        prevEl: this.$refs.prev,
        nextEl: this.$refs.next,
      },
      modules: [Navigation],
    });
  },

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  },
});
